import React, { isValidElement } from 'react';
import { isRcElement } from '../../../foundation';
import { RcIcon } from '../../Icon';
export var CustomIconPropsGetter = function (options) {
    var defaultIcon = options.icon, defaultCheckedIcon = options.checkedIcon, defaultIndeterminateIcon = options.indeterminateIcon;
    return function (props) {
        var size = props.size, iconProp = props.icon, checkedIconProp = props.checkedIcon, indeterminateIconProp = props.indeterminateIcon;
        var resultProps = {};
        var icon = getResultIcon(iconProp, size, defaultIcon);
        if (icon)
            resultProps.icon = icon;
        var checkedIcon = getResultIcon(checkedIconProp, size, defaultCheckedIcon);
        if (checkedIcon)
            resultProps.checkedIcon = checkedIcon;
        var indeterminateIcon = getResultIcon(indeterminateIconProp, size, defaultIndeterminateIcon);
        if (indeterminateIcon)
            resultProps.indeterminateIcon = indeterminateIcon;
        return resultProps;
    };
};
function getResultIcon(iconProp, size, defaultIcon) {
    var icon;
    if (iconProp) {
        if (isRcElement(iconProp, ['RcIcon']) && size) {
            icon = cloneProps(iconProp, size);
        }
        else {
            icon = iconProp;
        }
    }
    if (!icon && defaultIcon) {
        icon = isValidElement(defaultIcon) ? (cloneProps(defaultIcon, size)) : (React.createElement(RcIcon, { symbol: defaultIcon, size: size }));
    }
    return icon;
}
function cloneProps(iconProp, size) {
    return React.cloneElement(iconProp, {
        size: size,
    });
}
